import React, { useEffect, useRef } from 'react';

const IntroSound = ({ shouldPlay, isEnabled }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    const playAudio = async () => {
      if (shouldPlay && audioRef.current && isEnabled) {
        try {
          audioRef.current.currentTime = 0;
          audioRef.current.volume = 1.0;
          await audioRef.current.play();
          console.log('Audio started playing');
        } catch (error) {
          console.error('Error playing audio:', error);
        }
      }
    };

    playAudio();
  }, [shouldPlay, isEnabled]);

  return (
    <audio 
      ref={audioRef} 
      src="/intro.mp3" 
      preload="auto"
    />
  );
};

export default IntroSound; 